import { createAuthClient } from 'better-auth/react';
import { magicLinkClient } from 'better-auth/client/plugins';

const API_URL =
  (import.meta.env.VITE_API_URL as string | undefined) ||
  'http://localhost:8787';

export const authClient = createAuthClient({
  baseURL: API_URL,
  plugins: [magicLinkClient()],
});

export const { signIn, signOut, useSession } = authClient;
